import MainNavigation from "./MainNavigation";
// Initialise the main navigation component
const mainNavigationElem = document.querySelector("[data-main-nav]");
if (mainNavigationElem) {
  new MainNavigation(mainNavigationElem);
}
